<template>
  <section class="page-container">
    <div class="flex-sb-center">
      <h1>New Quote</h1>
      <v-button
        gray
        @click="handleBack">Back</v-button>
    </div>
    <div class="type-container">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="type-box card"
        @click="typeClick(item)">
        <div class="img-container">
          <!--          <img-->
          <!--            :src="item.img"-->
          <!--            alt="type" />-->
          <div
            class="hbanner-def"
            :class="item.logo"></div>
        </div>
        <span class="type-label">{{ item.label }}</span>
        <div class="type-container-span">
          <span
            v-for="type in item.typeList"
            :key="type"
            class="span-checkbox">
            {{ type }}
          </span>
        </div>
      </div>
    </div>
    <span class="list-title">SME Business Package</span>
    <div class="type-container">
      <div
        v-for="(item, index) in smeList"
        :key="'sme'+index"
        class="type-box card"
        @click="typeClick(item,1)">
        <div class="icon-container">
          <!--          <img-->
          <!--            :src="item.img"-->
          <!--            alt="type" />-->
          <font-awesome-icon :icon="item.icon"></font-awesome-icon>
        </div>
        <span class="type-label">{{ item.label }}</span>
        <div class="type-container-span">
          <span
            v-for="type in item.typeList"
            :key="type"
            class="span-checkbox">
            {{ type }}
          </span>
        </div>
      </div>
    </div>
    <span class="list-title">Contracts All Risks</span>
    <div class="type-container">
      <div
        v-for="(item, index) in carList"
        :key="'sme'+index"
        class="type-box card"
        @click="typeClick(item,1)">
        <div class="icon-container">
          <font-awesome-icon :icon="item.icon"></font-awesome-icon>
        </div>
        <span class="type-label">{{ item.label }}</span>
        <div class="type-container-span">
          <span
            v-for="type in item.typeList"
            :key="type"
            class="span-checkbox">
            {{ type }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {mapActions} from 'vuex'
import {getQuoteAllNew} from '@api/quote'

export default {
  name: 'Quoting',
  data() {
    return {
      list: [
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Motorcycle',
          classId:14,
          typeList: ['Personal', 'Company'],
          logo: 'Motorcycle',
        },
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Private Car',
          logo: 'PrivateCar',
          classId:11,
          typeList: ['Personal', 'Company']
        },
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Commercial Vehicle',
          logo: 'CommercialVehicle',
          classId:12,
          typeList: ['Personal', 'Company']
        },
        {
          img: require('@/assets/images/quote/banner-housemaid.png'),
          productId: 12,
          label: 'Domestic Helper',
          logo: 'Housemaid',
          typeList: ['Personal'],
          classId:21,
        },

        {
          img: require('@/assets/images/quote/banner-home.png'),
          label: 'Home',
          logo: 'Home',
          typeList: ['Personal', 'Company'],
          productId: 17,
          classId:26,
        },
        {
          img: require('@/assets/images/quote/banner-fire.png'),
          label: 'Fire',
          logo: 'Fire',
          typeList: ['Personal', 'Company'],
          productId: 20,
          classId:29,
        },
        {
          img: require('@/assets/images/quote/banner-travel.png'),
          productId: 14,
          label: 'Travel',
          logo: 'Travel',
          typeList: ['Personal'],
          classId:23,
        },
        {
          img: require('@/assets/images/quote/banner-overseas-student.png'),
          label: 'Overseas Student',
          logo: 'OverseasStudent',
          typeList: ['Personal'],
          productId: 16,
          classId:25,
        },
        {
          img: require('@/assets/images/quote/banner-working.png'),
          productId: 13,
          label: 'Working Holiday',
          logo: 'WorkingHoliday',
          typeList: ['Personal'],
          classId:22,
        },
        {
          img: require('@/assets/images/quote/banner-personal-accident.png'),
          label: 'Personal Accident',
          logo: 'PersonlAccident',
          typeList: ['Personal'],
          productId: 18,
          classId:27,
        },
        {
          img: require('@/assets/images/quote/banner-interior.png'),
          label: 'Interior Decoration',
          typeList: ['Company'],
          productId: 15,
          classId:24,
        },

        {
          label: 'Pet Insurance',
          typeList: ['Personal'],
          logo: 'Pet',
          productId: 22,
          classId:31,
        },
        {
          label: 'Motor Trade',
          typeList: ['Personal', 'Company'],
          logo: 'MotorTrade',
          productId: 11,
          classId:13,
        },
        {
          label: 'HZMB',
          typeList: ['Personal'],
          logo: 'hzmb',
          productId: 11,
          classId:15,
        }
      ],

    }
  },
  computed:{
    severType(){
      let {severType} = this.$route.params
      return severType
    },
    isFina(){
      let path = this.$route.path
      return path.includes('/fina/')
    },
    smeList(){
      return [
        {
          icon: 'utensils',
          productId: 81,
          path:'/create/sme/tickets',
          label: 'Catering',
          typeList: ['Company']
        },
        {
          icon: 'door-closed',
          productId: 82,
          path:'/create/sme/tickets',
          label: 'Pure Office',
          typeList: ['Company']
        },


        {
          icon: 'store',
          label: 'Retail Shop',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 83
        },

        //
        // {
        //   icon: 'spray-can-sparkles',
        //   label: 'Beauty Center',
        //   path:'beauty',
        //   typeList: [ 'Company'],
        //   productId: 84
        // },
        // {
        //   icon: 'scissors',
        //   label: 'Hair Salon',
        //   path:'hair',
        //   typeList: [ 'Company'],
        //   productId: 86
        // },
        // {
        //   icon: 'school',
        //   productId: 85,
        //   path:'education',
        //   label: 'Education Center',
        //   typeList: ['Company']
        // },
        // {
        //   icon: 'house-chimney-medical',
        //   label: 'Medical Center / Clinic',
        //   path:'medical',
        //   typeList: ['Company'],
        //   productId: 88
        // },
        {
          icon: 'comment-dots',
          label: 'Other',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 89
        },
      ]
    },
    carList(){
      return [
        {
          icon: 'briefcase',
          label: 'Contracts All Risks',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 79
        },
      ]
    },
  },
  created() {
    // this.updateAllOptions()
    // this.updateAllOptions(11)
    // this.updateAllOptions(12)
  },
  methods: {
    ...mapActions('common', ['setProductId','setCarClassId']),
    ...mapActions('quote',['setQuoteForm','setAllQuote','setQuoteResult']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    ...mapActions('coupon', ['setSelectCode','setCouponData','setReferrerData']),
    ...mapActions('smeQuote', ['setSmeQuickForm']),
    handleBack(){
      let params = {}
      let hasCustomer = this.$route.query.hasCustomer||false
      if(hasCustomer){
        params.hasCustomer  = true
      }
      this.$router.push({
        path:'/quoting/select/create',
        query:{
          ...params
        }
      })
    },
    typeClick({ productId,path,classId },type) {
      let {hasCustomer} = this.$route.query||{}
      this.setReferrerData(null)
      if(productId) {
        this.setProductId(productId)
        this.setCarClassId(classId)
        this.setQuoteForm(null)
        if(!hasCustomer)
        {
          this.setCustomerId(null)
          this.setSelectCustomerData(null)
          this.setReferCustomerId(null)
          this.setSelectReferCustomerData(null)
        }

        this.setSelectCode(null)
        this.setCouponData(null)
        if(type==1){
          this.setSmeQuickForm(null)
          // this.$router.push(`/quoting/${path}/underwriting`)
          this.$router.push(`/create/sme/${this.severType}/tickets/${productId}`)
          return
        }
        if(productId == 13){
          this.network().getQuoteAllNew({class_id: 22})
        }else{
          this.$router.push(`/quoting/${this.severType}/underwriting`)

        }
      }
    },
    network() {
      return {
        // 采用新版報價接口
        getQuoteAllNew: async (params) => {
          params = {  class_id: 22}
          const {data} = await getQuoteAllNew({  class_id: 22})
          this.setQuoteForm(params)

          if (!data.list || data.list.length < 1) {
            if (this.isReferralRequest) {
              this.$emit('refer')
              return
            }

            this.$router.push({
              name: 'quotingRefer',
              query: {
                product_id: this.productId
              }
            })
            return
          }

          this.setAllQuote(data.list)
          this.setQuoteResult(data)

          if (this.isReferralRequest) {
            this.$emit('success')
            return
          }
          this.$router.push({
            path: `/quoting/${this.severType}/quote`,
            query: {
              product_id: this.productId
            }
          })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  color: #303133;
  margin: -20px;
  padding: 30px 70px;
  background: #fff;
  min-height: 100vh;
  .hbanner-def{
    background-image: url("~@/assets/images/quote/productlist.png");
    background-repeat: no-repeat;
    width: 68px;
    height: 68px;
    background-size: 1156px 68px;
    &.Motorcycle{
      background-position: -816px 0;
    }
    &.PrivateCar{
      background-position: -68px 0;
    }
    &.PersonlAccident{
      background-position: -136px 0;
    }
    &.Home{
      background-position: -748px 0;
    }
    &.Fire{
      background-position: -544px 0;
    }
    &.Housemaid{
      background-position: -952px 0;
    }
    &.Travel{
      background-position: -340px 0;
    }
    &.OverseasStudent{
      background-position: -476px 0;
    }
    &.WorkingHoliday{
      background-position: -272px 0;
    }
    &.CommercialVehicle{
      background-position: -680px 0;
    }
    &.InteriorDecoration{
      background-position: -884px 0;
    }
    &.DroneLiability{
      background-position: -612px 0;
    }
    &.ReturnShipment{
      background-position: -204px 0;
    }
    &.SportsPA{
      background-position: -408px 0;
    }
    &.Pet{
      background-position: -1020px 0;
    }
    &.MotorTrade{
      background-position: -1088px 0;
    }
  }
  .hzmb{
    background-image: url("~@/assets/images/quote/hzmb.png");
    background-repeat: no-repeat;
    width: 68px;
    height: 68px;
    background-size: 68px 68px;
  }
    h1 {
        font-size: 34px;
    }
  .list-title{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px ;
    margin-bottom: 20px;
    display: inline-block;
  }
    .type-container {
        display: flex;
        flex-wrap: wrap;
        .type-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 20px;
          margin-bottom: 20px;
          text-align: center;
          width: 184px;
          height: 170px;
          cursor: pointer;
          border: 1px solid #D1D5DA;
          border-radius: 5px;
          box-shadow: none;
            .img-container {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              width: 120px;
              height: 80px;
              img {
                max-width: 120px;
                max-height: 80px;
              }
            }
            .icon-container{
              font-size: 64px;
              color: #6A737D;
            }
            .type-label {
              font-family: 'Inter';
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 20px;
              color: #303133;
            }
            .type-container-span {
              padding-top: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              span:nth-of-type(2) {
                margin-left: 10px;
              }
            }
          .span-checkbox {
            display: inline-block;
            padding: 0 10px;
            height: 20px;
            line-height: 18px;
            color: #586069;
            font-size: 12px;
            border-radius: 100px;
            border: 1px solid #e1e4e8;
            background: #fff;
            word-wrap: none;
            white-space: nowrap;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 600;
          }
        }
    }
}
</style>
